// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import { installTurboConfirm } from "./turbo_confirm"

installTurboConfirm()

import "./controllers"
import * as bootstrap from "bootstrap"

// Import Font Awesome
import "@fortawesome/fontawesome-free/js/fontawesome"
import "@fortawesome/fontawesome-free/js/solid"
import "@fortawesome/fontawesome-free/js/regular"
import "@fortawesome/fontawesome-free/js/brands"
